import type { SystemStyleObject } from '@companydotcom/potion';

const parts = ['container', 'divider', 'form', 'formButton', 'fields'];

const baseStyleContainer: SystemStyleObject = {
  paddingTop: 14,
  paddingBottom: '80px',
  maxWidth: 776,
  marginX: 'auto',
  paddingX: 5,
};

const baseStyleDivider: SystemStyleObject = {};

const baseStyleForm: SystemStyleObject = {};

const baseStyleFields: SystemStyleObject = {
  paddingTop: 7,
  paddingBottom: 10,
  borderRadius: 'md',
  marginBottom: 10,
};

const baseStyleFormButton: SystemStyleObject = {};

const baseStyle = () => ({
  container: baseStyleContainer,
  divider: baseStyleDivider,
  form: baseStyleForm,
  formButton: baseStyleFormButton,
  fields: baseStyleFields,
});

export default {
  parts,
  baseStyle,
};
